import { render, staticRenderFns } from "./EventManager.vue?vue&type=template&id=b4555a58&scoped=true&"
import script from "./EventManager.script.js?vue&type=script&lang=js&"
export * from "./EventManager.script.js?vue&type=script&lang=js&"
import style0 from "./EventManager.scss?vue&type=style&index=0&id=b4555a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4555a58",
  null
  
)

export default component.exports